// ConfirmDeleteDialog.js
import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogContentText,
    DialogActions, Button, CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmDeleteDialog({ open, count, onCancel, onConfirm, loading }) {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onClose={loading ? null : onCancel}>
            <DialogTitle>
                {count > 1 ? t('deleteDialog.titleMany', { count }) : t('deleteDialog.titleOne')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {count > 1
                        ? t('deleteDialog.bodyMany', { count })
                        : t('deleteDialog.bodyOne')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={loading}>
                    {t('cancel')}
                </Button>
                <Button onClick={onConfirm} color="error" disabled={loading} autoFocus>
                    {loading ? <CircularProgress size={18} /> : t('delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
